import { Group, Text } from "@mantine/core";
import { IconFilter } from "@tabler/icons-react";

interface OverviewFilterCaptionProps {
	// What the "filtered" figures are counted over, e.g. "Acme · Active"
	label: string | null;
}

function OverviewFilterCaption({ label }: OverviewFilterCaptionProps) {
	if (!label) return null;
	return (
		<Group
			gap={4}
			c="blue">
			<IconFilter size={14} />
			<Text size="sm">Filtered: {label}</Text>
		</Group>
	);
}

export default OverviewFilterCaption;
